import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh, useRecordContext, useGetOne, useShowController } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import PhoneIcon from '@mui/icons-material/Phone'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import EditIcon from '@mui/icons-material/Edit'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { HotelRooms } from 'src/components/pages/sales/reservation/logic/hotel/HotelRooms'
import { HotelCancellation } from 'src/components/pages/sales/reservation/logic/hotel/HotelCancellation'
import { DateProduct } from 'src/components/pages/sales/reservation/logic/common/DateProduct'
import RoomServiceIcon from '@mui/icons-material/RoomService'
import { turquoise, blue } from 'src/assets/colors'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { PricingModal } from 'src/components/pages/sales/reservation/logic/modals/PricingModal'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { HotelForm } from 'src/components/pages/sales/reservation/logic/hotel/HotelForm'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_SMARTBOOK, ITEM_PERMISSION_ENTITY, PERMISSION_IS_BILLABLE } from 'src/helper/Permission'
import { EditOriginValues } from '../common/EditOriginValues'
import { guaranteeItemReservation } from 'src/components/pages/sales/reservation/helper/guaranteeItemReservation'
import { cancelStatusItemReservation } from 'src/components/pages/sales/reservation/helper/cancelStatusItemReservation'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { Comment, RemoveRedEye } from '@mui/icons-material'
import { itemServices } from 'src/services/reservation/item/item.service'
import { ComplementaryItemModal } from 'src/components/pages/sales/reservation/logic/modals/ComplementaryItemModal'
import { CreateItemSupplierModal } from 'src/components/pages/sales/reservation/logic/modals/CreateItemSupplierModal'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  PERMISSION_GET,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'
import { HotelCondition } from './HotelCondition'
import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { refreshHotelItemReservation } from 'src/components/pages/sales/reservation/helper/refreshHotelItemReservation'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { useReservationInfo } from '../../context/ReservationContext'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { ExchangeType } from '../common/ExchangeType'
import { CommentsCardComponent } from '../common/CommentsCardComponent'
import { PostVentaStatus } from '../common/postventaStatus'
import { registerReturn } from '../../helper/registerReturn'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import ReactJson from 'react-json-view'
import { HotelCodeEditModal } from '../modals/HotelCodeEditModal'
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { timeZoneFormat } from '../../helper/argToTimezoneFormat'
import { ItemCancellation } from '../common/AutoCancelFields'
import { ChangePaymentStatusDialog } from '../common/ChangePaymentStatusDialog'
import { ChangeBillingStatusDialog } from '../common/ChangeBillingStatusDialog'
import { LoadingButton } from '@mui/lab'

const PassengerHotel = ({ reservation }) => {
  const hotel = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = hotel?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ContextHotel = ({ reservation }) => {
  const hotel = useRecordContext()
  const translate = useTranslate()
  const [openModalCondition, setOpenModalCondition] = useState(false)

  if (hotel) {
    return (
      <>
        <DateProduct date_in={hotel?.date_in} date_out={hotel?.date_out} />
        <HotelRooms hotel={hotel} rooms={hotel?.rooms} pax_length={hotel?.pax_relation?.length} />
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        {/* <HotelCancellation
          autoCancelDate={hotel?.autocancel_date}
          cancellations={hotel?.cancel_info_relation}
        /> */}
        <ItemCancellation
          autoCancelDate={hotel?.autocancel_date}
          cancellations={hotel?.cancel_info_relation}
        />
        <Button
          onClick={() => setOpenModalCondition(true)}
          style={{ fontWeight: 600, textDecoration: 'underline', marginTop: 10 }}
        >
          {translate('ra.action.see_conditions_provider')}
        </Button>
        <Passenger itemId={hotel.item_id} passengers={hotel?.pax_relation} idResource={reservation?.id} />

        <HotelCondition
          open={openModalCondition}
          handleClose={() => setOpenModalCondition(false)}
          hotel={hotel}
        />
      </>
    )
  }
}

const ContextHotelForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const hotel = useRecordContext()
  if (hotel && openProductModal) {
    return (
      <HotelForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={hotel}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={hotel}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const LiquidationCards = ({ work_unit_relation, enableReliquidation}) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const refresh = useRefresh()
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)
  
  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
        
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    
  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }

  const handleCLickRule = (ruleId) => {
    if (ruleId) {
      window.open(`/#/business-rule/${ruleId}`, '_blank')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied}
                  </Button>
                  {item?.auth_code && (
                    <Tooltip title={`${translate('ra.field.rule_price_short')} ${item?.auth_code}`}>
                      <RemoveRedEye color='primary' />
                    </Tooltip>
                  )}
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing
                    node_liquidation='liquidation_wholesaler'
                    work_unit_relation={work_unit_relation}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              posTitle={
                <HasPermission resource={'business-rule'} permission='view'>
                  <Box sx={{ flex: 1, textAlign: 'end' }}>
                    <Button
                      variant='text'
                      onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied)}
                    >
                      {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied}
                    </Button>
                  </Box>
                </HasPermission>
              }
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing
                      node_liquidation='liquidation_retail'
                      work_unit_relation={work_unit_relation}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing
                    node_liquidation='liquidation_supplier'
                    work_unit_relation={work_unit_relation}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
        title={decideLiquidation()}
        contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
        buttonConfirmText={translate('ra.message.yes')}
        buttonCancel={translate('ra.message.no')}
        setOpen={setOpenReliquidateModal}
        setConfirm={setConfirmReliquidate}
        open={openReliquidateModal}
        loadingModalButton={reliquidateLoading}
      />
    </>
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const hotel = useRecordContext()
  if (hotel) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={hotel} />
      </ShowCard>
    )
  }
}

const ContextSmartbook = () => {
  const translate = useTranslate()
  const hotel = useRecordContext()
  const [openSmartbookDialog, setOpenSmartbookDialog] = useState(false)

  return <>
    <ShowElement
      label="Smartbook"
      data={
        <Button
          disabled={!hotel.smartbook}
          onClick={() => setOpenSmartbookDialog(true)}
          size="small"
          variant={'contained'}
          style={{ padding: '0 10px' }}
        >
          {hotel.smartbook ? translate('ra.boolean.true') : translate('ra.boolean.false')}
        </Button>
      }
    />

    <Dialog
      open={openSmartbookDialog}
      onClose={() => setOpenSmartbookDialog(false)}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>{translate('ra.field.smartbookTitle')}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          {translate('ra.field.smartbookOriginalProvider')}
        </Typography>
        <Typography gutterBottom>
          {hotel.smartbook?.GetSegmentSmartBookDataResult?.Segments?.[0]?.OriginalSupplierName || '—'}
        </Typography>
        <Typography variant="subtitle2" gutterBottom style={{ marginTop: 10 }}>
          {translate('ra.field.smartbookJson')}
        </Typography>
        <ReactJson
          src={hotel.smartbook || {}}
          style={{ backgroundColor: 'white' }}
          name={null}
          iconStyle='triangle'
          collapsed={false}
          enableClipboard={false}
          displayDataTypes={false}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color='error'
          variant='outlined'
          onClick={() => setOpenSmartbookDialog(false)}
        >
          {translate('ra.action.close')}
        </Button>
      </DialogActions>
    </Dialog>
  </>
}

const ContextRebooker  = () => {
  const translate = useTranslate()
  const hotel = useRecordContext()
  const [openRebookerDialog, setOpenRebookerDialog] = useState(false)

  return <>
    <ShowElement
      label={translate('ra.field.rebooker')}
      data={
        <Button
          disabled={!hotel.rebooker}
          onClick={() => setOpenRebookerDialog(true)}
          size="small"
          variant={'contained'}
          style={{ padding: '0 10px' }}
        >
          {hotel.rebooker ? translate('ra.boolean.true') : translate('ra.boolean.false')}
        </Button>
      }
    />

    <Dialog
      open={openRebookerDialog}
      onClose={() => setOpenRebookerDialog(false)}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>{translate('ra.field.rebooker')}</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          {translate('ra.field.provider')}
        </Typography>
        <Typography gutterBottom>
          {hotel.rebooker?.GetSegmentRebookerDataResult?.Segments?.[0]?.providername || '—'}
        </Typography>
        <Typography variant="subtitle2" gutterBottom style={{ marginTop: 10 }}>
          {translate('ra.field.json')}
        </Typography>
        <ReactJson
          src={hotel.rebooker || {}}
          style={{ backgroundColor: 'white' }}
          name={null}
          iconStyle='triangle'
          collapsed={false}
          enableClipboard={false}
          displayDataTypes={false}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color='error'
          variant='outlined'
          onClick={() => setOpenRebookerDialog(false)}
        >
          {translate('ra.action.close')}
        </Button>
      </DialogActions>
    </Dialog>
  </>
}

const ReserveInformation = ({reservation, refresh, isBillable, setIsBillable, setOpenDisableRebookerDialog}) =>{
  const translate = useTranslate()
  const notify = useNotify()
  const [loadingBillable, setLoadingBillable] = useState(false)
  const [openCodeModal, setOpenCodeModal] = useState(false)
  const [changeStatusDialog, setChangeStatusDialog] = useState(false)
  const [changePaymentStatusDialog, setChangePaymentStatusDialog] = useState(false)
  const [changeBillingStatusDialog, setChangeBillingStatusDialog] = useState(false)
  const hotel = useRecordContext();
  const {
      isFetching
    } = useShowController()
  

  const onChangeBillable = async () =>{
    const newValue = isBillable != undefined ? !isBillable: !hotel?.is_billable
    setLoadingBillable(true)
    setIsBillable(newValue)
    await reservationServices.updateIsBillableProduct(hotel.hash_, newValue).then(()=>{
      notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
    }).catch(()=>{
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    }).finally(()=>{
      setLoadingBillable(false)
    })
  }
  return(
    <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
      <CompleteSideCard>
        <Box display={'flex'}>
          <LeftSideCard>
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
              <ShowElement source='status' label={translate('ra.field.status')} />
              <HasPermission resource={'item'} permission='edit_status'>
                <EditIcon onClick={()=>setChangeStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
              </HasPermission>
            </div>
            <ShowElement
              source='created_at'
              label={translate('ra.field.created_at')}
              dateFormatCustom={timeZoneFormat}
            />
            <ShowElement
              source='source_relation.short_name'
              label={translate('ra.field.source')}
            />
          </LeftSideCard>
          <RigthSideCard>
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
              <ShowElement
                source={'payment_status'}
                label={translate('ra.field.payment_status')}
                status
              />
              <HasPermission resource={'item'} permission='edit_payment_status'>
                <EditIcon onClick={()=>setChangePaymentStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
              </HasPermission>
            </div>
            <PassengerHotel reservation={reservation} />
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
              <BillingStatusField />
              <HasPermission resource={'billing'} permission='edit_status'>
                <EditIcon onClick={()=>setChangeBillingStatusDialog(true)} style={{cursor:'pointer', fontSize:'17px', color:'#6f7ce0', marginLeft:'12px'}}/>
              </HasPermission>
            </div>

            {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
              <Box style={{padding: '5px 0px 5px 0px'}}>
                <Typography
                    variant='h7'
                    component='span'
                    style={{
                      padding: '0px 5px 0px 5px',
                      fontWeight: 600,
                      flex: 1,
                      maxWidth: 'fit-content',
                      display: 'inline-flex', 
                      alignItems: 'center',    
                      gap: '6px' 
                    }}
                  >
                  {translate('ra.field.is_billable')}
                  <Checkbox
                    checked={isBillable != undefined?isBillable:hotel?.is_billable}
                    onChange={onChangeBillable}
                    disabled={loadingBillable || isFetching}
                  />
                  {isFetching && (
                    <CircularProgress size={'10px'} sx={{ marginX: '5px' }} />
                  )}
                </Typography>
              </Box>
            )}
            <BillingAutomaticField />
          </RigthSideCard>
        </Box>
        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
          {translate('ra.title.provider_info')}
        </Typography>
        <Box display={'flex'}>
          <LeftSideCard>
            <HasPermission
              permission={'show'}
              resource={'supplier'}
            >
            <ShowElement
              source='supplier_relation.name'
              label={translate('ra.field.provider')}
            />
            </HasPermission>
            <ShowElement
              source='pricing_relation.[0].currency_origin'
              label={translate('ra.field.currency')}
            />
            <HasPermission
              permission={PERMISSION_SMARTBOOK}
              resource={ITEM_PERMISSION_ENTITY}
            >
              <ContextSmartbook />
            </HasPermission>
            <HasPermission
              permission={'rebooker_view'}
              resource={'item'}
            >
              <ContextRebooker/>
            </HasPermission>
          </LeftSideCard>
          <RigthSideCard>
            <HasPermission resource={'hotel-detail'} permission='show_codes'>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', whiteSpace:'nowrap'}}>
              <ShowElement source={'gmx_order_id'} label={`${translate('ra.field.provider_code')} 1`} />
              <EditIcon 
                color={hasPermissionFunction('hotel-detail', 'edit_codes')?'primary':'disabled'}
                onClick={()=>hasPermissionFunction('hotel-detail', 'edit_codes') && setOpenCodeModal(true)} 
                style={{fontSize:'18px', cursor:hasPermissionFunction('hotel-detail', 'edit_codes') ? 'pointer':'default'}}
              />
            </div>
            <ShowElement
                source={'provider_code'}
                label={`${translate('ra.field.provider_code')} 2`}
                style={{whiteSpace:'nowrap'}}
            />
            </HasPermission>
            <ShowElement
              source={'gmx_segment_id'}
              label={translate('ra.field.gmx_segment_id')}
              style={{whiteSpace:'nowrap'}}
            />
            <HasPermission resource='hotel-detail' permission='edit_codes'>
              <ShowElement source={'code_original'} label={`${translate('ra.field.code')}`} style={{whiteSpace:'nowrap'}}/>
            </HasPermission>
            {!hotel.import_id && 
            <HasPermission resource='hotel-detail' permission='rebooker_disable'>
                <Button
                  style={{marginTop:'10px'}}
                  variant='contained'
                  disabled = {hotel.disable_rebooker}
                  onClick={()=>setOpenDisableRebookerDialog(true)}
                >
                  {translate('ra.action.disable_rebooker')}
                </Button>
            </HasPermission>}
          </RigthSideCard>
        </Box>
      </CompleteSideCard>
        <ChangeStatusDialog
            open={changeStatusDialog}
            setOpen={setChangeStatusDialog}
            refresh={refresh}
          />
        <ChangePaymentStatusDialog
          open={changePaymentStatusDialog}
          setOpen={setChangePaymentStatusDialog}
          refresh={refresh}
        />
        <ChangeBillingStatusDialog
          open={changeBillingStatusDialog}
          setOpen={setChangeBillingStatusDialog}
          refresh={refresh}
        />

      <Dialog
          open={openCodeModal}
          onClose={()=>setOpenCodeModal(false)}
        >
        <DialogTitle>
          {translate('ra.title.code_edit')}
        </DialogTitle>
        <DialogContent>
          <HotelCodeEditModal refresh={refresh} setOpenCodeModal={setOpenCodeModal} />
        </DialogContent>
        </Dialog>
    </ShowCard>
  )
}

const DestinationType = () =>{
  const translate = useTranslate()
  const hotel = useRecordContext()
  return(
    (hotel?.destination_type && 
      (hotel?.destination_type === 1 || 
      hotel?.destination_type === 2)) &&
      <ShowElement
        data={
          hotel?.destination_type === 1 ? 
          translate('ra.destination_type.international') :
          translate('ra.destination_type.national')
        }
        styleValue={{ fontWeight: 600, color: turquoise }}
        label={translate('ra.field.destination_type')}
      />
  )
}

export const HotelProduct = ({ reservation, hotel, editMode = false }) => {
  const product = useRecordContext()
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [open, setOpen] = useState(false)
  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')
  const [hashItemReserveForceCancel, setHashItemReserveForceCancel] = useState('')

  const [confirm, setConfirm] = useState(false)
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const [forcedCancel, setForcedCancel] = useState(false)
  const [confirmForcedCancel, setConfirmForcedCancel] = useState(false)
  const [loadingCancelStatusItem, setLoadingCancelStatusItem] = useState(false)

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)

  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false)
  const [confirmGuarantee, setConfirmGuarantee] = useState(false)
  const [loadingGuaranteeItem, setLoadingGuaranteeItem] = useState(false)

  const [openRefreshHotelModal, setOpenRefreshHotelModal] = useState(false)
  const [confirmRefreshHotel, setConfirmRefreshHotel] = useState(false)
  const [loadingRefreshHotel, setLoadingRefreshHotel] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)

  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)
  // const [individualRecord, setIndividualRecord] = useState({})
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)
  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)

  // const [exchangeMode, setExchangeMode] = useState(false)
  const { setOpenDueDateModal } = useReservationInfo()
  const [openProductModal, setOpenProductModal] = useState(false)
  const { setCardLoading } = useCardLoading()

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [historyCostsDialog, setHistoryCostsDialog] = useState()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [openDisableRebookerDialog, setOpenDisableRebookerDialog] = useState(false)
  const [disableRebookerConfirm, setDisableRebookerConfirm] = useState(false)
  const [disableRebookerLoading, setDisableRebookerLoading] = useState(false)

  const [openAfterSalesItemModal, setOpenAfterSalesItemModal] = useState(false)
  const [confirmAfterSalesItem, setConfirmAfterSalesItem] = useState(false)
  const [loadingAfterSalesReservationItem, setLoadingAfterSalesReservationItem] = useState(false)

  const [openComplementaryModal, setOpenComplementaryModal] = useState(false)
  const [loadingComplementaryItem, setLoadingComplementaryItem] = useState(false)
  const [openCreateItemSupplierModal, setOpenCreateItemSupplierModal] = useState(false)
  const [itemSupplierItemId, setItemSupplierItemId] = useState(null)

  const [isBillable, setIsBillable] = useState()

  const [enableReliquidation, setEnableReliquidation] = useState(false)
  
  const disableRebooker = async () =>{
    setDisableRebookerLoading(true)
    await itemServices.disableRebooker(hotel[0].hash_).then(()=>{
      notify('ra.notification.disable_rebooker_success', {type:'success'})
      setOpenDisableRebookerDialog(false)
    }).catch((err)=>{
      if(err?.response?.status === 404){
        notify('Error de comunicacion con api externa', {type:'error'})
      } else { 
        notify('ra.notification.disable_rebooker_error', {type:'error'})
      }
    }).finally(()=>{
      setDisableRebookerLoading(false)
      setDisableRebookerConfirm(false)
    })
  }

  useEffect(() => {
    if (disableRebookerConfirm) {
      disableRebooker()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableRebookerConfirm])


  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
    if (confirmAfterSales) {
      afterSalesItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingAfterSalesItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmAfterSales,
        setOpenAfterSalesModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSales])

  useEffect(() => {
    if (changePostVentaStatus) {
      PostVentaStatus({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingPostventaStatus,
        setNameReserve,
        setHashItemReserve,
        setChangePostventaStatus,
        actualStatus
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePostVentaStatus])

  useEffect(() => {
    if (confirmGuarantee) {
      guaranteeItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingGuaranteeItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmGuarantee,
        setOpenGuaranteeModal,
        onGuaranteeSuccess: () => {
          setOpenDueDateModal(true)
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmGuarantee])

  useEffect(() => {

      if (confirmRegisterReturn) {
        registerReturn({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingRegisterReturnItem,
          setNameReserve,
          setHashItemReserve,
          setConfirmRegisterReturn,
          setOpenRegisterReturnModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmRegisterReturn])

  useEffect(() => {
    if (confirmRefreshHotel) {
      refreshHotelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingRefreshHotel,
        setNameReserve,
        setHashItemReserve,
        setConfirmRefreshHotel,
        setOpenRefreshHotelModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRefreshHotel])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
        setForcedCancel,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
    if (confirmForcedCancel) {
      cancelStatusItemReservation({
        hashItemReserve: hashItemReserveForceCancel,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelStatusItem,
        setNameReserve,
        setHashItemReserve: setHashItemReserveForceCancel,
        setConfirmCancelStatus: setConfirmForcedCancel,
        setOpenCancelStatusModal: setForcedCancel,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmForcedCancel])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if(error.response.data?.detail){
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setOpenMoveModal(false)
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
      }
    }
  }


  if (hotel) {
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingCancelItem || loadingDeleteItem || loadingCancelStatusItem}
        >
          <CircularProgress color='inherit' />
        </Backdrop>

        <TabProduct
          products={hotel}
          labelGetter={(product) => (product?.id_detail ? product?.name : 'ERROR')}
          getStyle={(product) => (product?.id_detail ? null : { color: 'red' })}
        >
          {!editMode && (
            <ToolbarReservation
              resource='hotel-detail'
              loadingCancel={loadingCancelItem || loadingCancelStatusItem}
              onCancel={(hotel) => {
                setOpen(true)
                setHashItemReserve(hotel?.hash_)
                setHashItemReserveForceCancel(hotel?.hash_)
                setNameReserve(hotel?.name)
              }}
              reservation={reservation}
              onDeleted={(hotel) => {
                setOpenDeleteModal(true)
                setHashItemReserve(hotel?.hash_)
                setNameReserve(hotel?.name)
              }}
              loadingDeleteItem={loadingDeleteItem}
              onGuaranteed={(hotel) => {
                setOpenGuaranteeModal(true)
                setHashItemReserve(hotel?.hash_)
                setNameReserve(hotel?.name)
              }}
              loadingGuaranteeItem={loadingGuaranteeItem}
              onRefreshHotel={(hotel) => {
                setOpenRefreshHotelModal(true)
                setHashItemReserve(hotel?.hash_)
                setNameReserve(hotel?.name)
              }}
              loadingRefreshHotel={loadingRefreshHotel}
              onClone={(hotel) => {
                setOpenCloneModal(true)
                setHashItemReserve(hotel?.hash_)
                setNameReserve(hotel?.name)
              }}
              loadingCloneItem={loadingCloneItem}
              onMove={(hotel) => {
                setOpenMoveModal(true)
                setHashItemReserve(hotel?.hash_)
                setNameReserve(hotel?.name)
              }}
              loadingMoveItem={loadingMoveItem}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(hotel)=>{
                setOpenAfterSalesModal(true)
                setHashItemReserve(hotel?.hash_)
                setNameReserve(hotel?.name)}
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (hotel)=>{
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(hotel?.hash_)
                  setNameReserve(hotel?.name)}
              }
              loadingRegisterReturn = {loadingRegisterReturnItem}
              setLoadingRegisterReturn = {setLoadingRegisterReturnItem}
              postventaStatusButton={(hotel)=>{
                setChangePostventaStatus(true)
                setHashItemReserve(hotel?.hash_)
                setActualStatus(hotel.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
              onAfterSalesItem={(hotel) => {
                setOpenAfterSalesItemModal(true)
                setHashItemReserve(hotel?.hash_)
              }
              }
              onComplementary={(hotel) => {
                setOpenComplementaryModal(true)
                setHashItemReserve(hotel?.hash_)
              }}
              loadingComplementaryItem={loadingComplementaryItem}
              onItemSupplierCreate={(hotel) => {
                setItemSupplierItemId(hotel?.item_id ?? hotel?.id)
                setOpenCreateItemSupplierModal(true)
              }}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextHotelForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ReserveInformation 
                      reservation={reservation} 
                      refresh={refresh} 
                      isBillable={isBillable} 
                      setIsBillable={setIsBillable}
                      setOpenDisableRebookerDialog={setOpenDisableRebookerDialog}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.new_after_sales_item_confirmation')}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesItemModal}
                      setConfirm={setConfirmAfterSalesItem}
                      open={openAfterSalesItemModal}
                      loadingModalButton={loadingAfterSalesReservationItem}
                    />
                    <ComplementaryItemModal
                      open={openComplementaryModal}
                      hashItem={hashItemReserve}
                      onClose={() => setOpenComplementaryModal(false)}
                    />
                    <CreateItemSupplierModal
                      open={openCreateItemSupplierModal}
                      itemId={itemSupplierItemId}
                      onClose={() => setOpenCreateItemSupplierModal(false)}
                    />
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.title.price_history')}
                        <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setHistoryCostsDialog(false)}}/>
                      </DialogTitle>
                      <DialogContent>
                          <HistoryCostsDialog/>
                      </DialogContent>
                    </Dialog>
                    <ConfirmationDialog
                      title={translate('ra.message.guarantee_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenGuaranteeModal}
                      setConfirm={setConfirmGuarantee}
                      open={openGuaranteeModal}
                      loadingModalButton={loadingGuaranteeItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.refresh_retrive_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRefreshHotelModal}
                      setConfirm={setConfirmRefreshHotel}
                      open={openRefreshHotelModal}
                      loadingModalButton={loadingRefreshHotel}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />

                    {forcedCancel && (
                      <ConfirmationDialog
                        title={translate('ra.message.force_cancel')}
                        buttonConfirmText={translate('ra.message.yes')}
                        buttonCancel={translate('ra.message.no')}
                        setOpen={setForcedCancel}
                        setConfirm={setConfirmForcedCancel}
                        open={forcedCancel}
                      />
                    )}
                    
                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <LoadingButton loading={loadingMoveItem} variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </LoadingButton>
                      </DialogActions>
                    </Dialog>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard
                      iconHeader={<RoomServiceIcon />}
                      title={translate('ra.title.hotel_information')}
                    >
                      <CompleteSideCard style={{ display: 'block' }}>
                        <ShowElement
                          source='name'
                          styleValue={{ fontWeight: 600, color: turquoise }}
                          label={translate('ra.field.name')}
                        />
                        <ShowElement source='address' label={translate('ra.field.address')} />
                        <ShowElement
                          source='destination'
                          styleValue={{ fontWeight: 600, color: turquoise }}
                          label={translate('ra.field.destination')}
                          icon={<LocationOnIcon style={{ color: turquoise, paddingTop: '5px' }} />}
                        />
                        <DestinationType />
                        <ContextHotel reservation={reservation} />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <CommentsCardComponent />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  {/* <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.pricing')}
                    actionButtonIcon={<EditIcon />}
                    optionHeigth={'pricing'}
                    variant='text'
                    onClickButton={() => {
                      setOpenPricingModal(true)
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <Pricing />
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ShowCard> */}
                </WrapperCardId>
                <WrapperCardId>
                  <PricingModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    reservation={reservation}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <HasPermission permission='revision' resource={'pricing'}>
                          <Button
                            onClick={() => { setHistoryCostsDialog(true) }}
                            sx={{ paddingX: '10px', marginX: '5px' }}
                            size='small'
                            variant='contained'
                            >
                            {translate('ra.title.price_history')}
                            </Button>
                        </HasPermission>
                      </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal} />
                    </div>
                  )}

                  {/* <LiquidationModal
                    open={openLiqudiationPricingModal}
                    loadingButton={loadingLiqudiationPricingModal}
                    handleClose={() => {
                      setOpenLiqudiationPricingModal(false)
                      setExchangeMode(false)
                    }}
                    exchange_mode={exchangeMode}
                    onSubmit={(body, cardId) => {
                      handleUpdateLiquidation(
                        individualRecord,
                        body,
                        cardId,
                        setLoadingLiqudiationPricingModal,
                        setOpenLiqudiationPricingModal,
                        notify,
                        refresh,
                        setCardLoading
                      )
                      setExchangeMode(false)
                    }}
                    titleModal={translate('ra.title.update_liquidation')}
                  /> */}
                  <LiquidationCards enableReliquidation={enableReliquidation} work_unit_relation={reservation?.work_unit_relation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}